import { Console } from '~/lib/ApiModel';
import React from 'react';
import dayjs from 'dayjs';
import UnmountHelper from '~/lib/helper/UnmountHelper';

import './ConsolePane.scss';

export type ConsoleProps = {
    console: Console;
    refreshConsole: () => void;
};

const borderSize = 2;
const toolbarHeight = 40;

export default class ConsolePane extends React.Component<ConsoleProps> {
    unmountHelper = new UnmountHelper(this);

    componentDidMount() {
        // Check immediately on mount
        if (this.isExpired) {
            this.props.refreshConsole();
        }

        // Check every minute for expiry
        this.unmountHelper.intervalUntilUnmounted(() => {
            if (this.isExpired) {
                this.props.refreshConsole();
            }
        }, 60000); // Check every 60 seconds
    }

    get isExpired(): boolean {
        return dayjs(this.props.console.expiry).isBefore(dayjs());
    }

    render() {
        const frameWidth = this.props.console.width + borderSize * 2;
        const frameHeight = this.props.console.height + toolbarHeight + borderSize * 2;

        // use aspect ratio padding trick to make it responsive. remove the fixed/nonresponsive toolbar height
        // as we will use that as paddingBottom to compensate: paddingTop -> responsive, paddingBottom -> fixed
        const paddingAspectRatioPercent = ((frameHeight - toolbarHeight) / frameWidth) * 100;
        return (
            <div
                className="consolePane"
                style={{ paddingBottom: `${toolbarHeight}px`, paddingTop: `${paddingAspectRatioPercent.toFixed(2)}%` }}
            >
                <iframe
                    src={this.props.console.iframe}
                    width={frameWidth}
                    height={frameHeight}
                    title="Server console"
                />
            </div>
        );
    }
}
